export default ($axios) => ({
  fetch(query) {
    return $axios.get('/rcs/agents', { params: query }).then((response) => response.data);
  },
  find(agentId) {
    return $axios.get(`/rcs/agents/${agentId}`).then((response) => response.data);
  },
  updateAgent(agentId, payload) {
    return $axios.put(`/rcs/agents/${agentId}`, payload).then((response) => response.data);
  },
});
